import clsx from 'clsx';
import React, {
  ReactElement, Suspense, useEffect, useState
} from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Button } from '@/components/button/button';
import { Loader } from '@/components/loader/loader';
import { useAuthContext } from '@/hooks/useAuthContext';
import { parseParams } from '@/utils/searchParams';

type SearchParams = {
  invitation?: string;
};

function Auth0LoginPage() {
  const navigate = useNavigate();

  const {
    loginRedirect,
    sessionContext
  } = useAuthContext();

  /* DATA */
  const [ searchParams ] = useSearchParams();
  const {
    invitation: qInvitation
  } = parseParams<SearchParams>( searchParams );

  const [ error, setError ] = useState<string | undefined>( undefined );
  const [ isLoading, setIsLoading ] = useState<boolean>( true );

  useEffect( () => {
    ( async() => {
      try {
        // redirect if already logged in
        if ( sessionContext?.userId ) {
          navigate( '/', { replace: true } );
          return;
        }

        await loginRedirect( {
          invitation: qInvitation
        } );
      } catch( e ) {
        console.error( ( e as Error ).message );
        setError( 'An unexpected error occurred during authentication' );
      } finally {
        setIsLoading( false );
      }
    } )();
  }, [ loginRedirect, qInvitation, navigate, sessionContext ] );

  const ErrorEl = (): ReactElement => (
    <>
      <div className={ clsx( 'layout__row', 'pad' ) }>
        <h3>Authentication Error</h3>
      </div>
      <div className='layout__error'>
        { error }
      </div>
      <div className={ clsx( 'layout__row', 'pad', 'flex_right' ) }>
        <Button
          variant='primary'
          onClick={ () => navigate( '/login' ) }
        >
          Back to Login
        </Button>
      </div>
    </>
  );

  return (
    <div className={ clsx( 'page', 'center_xy' ) }>
      <div className='auth_flow_container'>
        {
          isLoading && <Loader />
        }
        {
          error && <ErrorEl />
        }
      </div>
    </div>
  );
}

export default function Page() {
  return (
    <Suspense fallback={ <Loader /> }>
      <Auth0LoginPage />
    </Suspense>
  );
}
